export const CONTENT_SLIDES = [
  {
    "id": "03136173-3103-458f-bf45-50de6494d558",
    "image": "slide1.jpg",
    "alt_image": "image slide 1",
    "text_html": `
        <p>Réserver devient encore plus facile<br>+ d'offres sur mesure.</p>
        <p>Trouver l'endroit idéal pour vos rencontres et répos sans vous déplacer !</p>
    `
  },
  {
    "id": "cb72e821-bb22-40f5-a22f-1e503b421325",
    "image": "slide2.jpg",
    "alt_image": "image slide 2",
    "text_html": `
      <p>Explorer plus d'option<br>Hôtel! Restaurant! Tourisme!</p>
      <p>Etendez les limites de vos divertissements touristiques! Avec des offres des partenaires Yebo juste pour vous. l'inscription sur la plateforme est gratuite!</p>
    `
  },
  {
    "id": "62c0976f-09a6-4d5b-8e06-a135c440eefa",
    "image": "slide3.jpg",
    "alt_image": "image slide 3",
    "text_html": `
        <p>Réserver devient encore plus facile<br>+ d'offres sur mesure.</p>
        <p>Trouver l'endroit idéal pour vos rencontres et répos sans vous déplacer !</p>
    `
  },
  {
    "id": "a471df59-e830-488e-a346-2e201a763513",
    "image": "slide4.jpg",
    "alt_image": "image slide 4",
    "text_html": `
      <p>Explorer plus d'option<br>Hôtel! Restaurant! Tourisme!</p>
      <p>Etendez les limites de vos divertissements touristiques! Avec des offres des partenaires Yebo juste pour vous. l'inscription sur la plateforme est gratuite!</p>
    `
  },
  {
    "id": "97cd4250-fa68-4e47-ac00-99c8f71c7f24",
    "image": "slide5.jpg",
    "alt_image": "image slide 5",
    "text_html": `
        <p>Réserver devient encore plus facile<br>+ d'offres sur mesure.</p>
        <p>Trouver l'endroit idéal pour vos rencontres et répos sans vous déplacer !</p>
    `
  },
]



// WEBPACK FOOTER //
// ./src/data/content_slides.js